export class WondeLinkStatusError {
  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'Invalid_Access':
        error = 'Invalid access';
        break;
      case 'Required':
        error = 'This is required';
        break;        
      default:
        error = 'Sorry something went wrong. Please try again.';
    }
    return error;
  };
};

export class WonderParser {};

export type SyncWondeDataResponse = {
  nonConformingPupils: string[];
  nonConformingSchoolUsers: string[];
};
